import React from 'react';
import { bottleImg, heroImg } from '../mock';

// Renders the luxury bottle image for a product.
// props: product { slug, name, accent, shots }, size ('sm'|'md'|'lg'|'fill')
export default function BottleLabel({ product, size = 'md', className = '' }) {
  const fill = size === 'fill';
  const src =
    (product?.shots && product.shots[0]) ||
    (product?.slug ? bottleImg(product.slug) : '') ||
    heroImg(product || {});

  const dims = fill
    ? 'w-full h-full'
    : size === 'lg'
      ? 'w-[min(72vw,300px)] h-[min(88vw,380px)]'
      : size === 'sm'
        ? 'w-[72px] h-[90px] sm:w-[120px] sm:h-[150px]'
        : 'w-[150px] h-[195px] sm:w-[200px] sm:h-[260px]';

  return (
    <div className={`relative flex items-center justify-center ${dims} ${className}`}>
      {src ? (
        <img
          src={src}
          alt={`${product?.name || 'Perfume'} bottle`}
          width={fill ? 600 : 400}
          height={fill ? 600 : 520}
          loading="lazy"
          decoding="async"
          className={`w-full h-full select-none pointer-events-none ${
            fill ? 'object-cover' : 'object-contain drop-shadow-xl'
          }`}
          style={fill ? undefined : { mixBlendMode: 'multiply' }}
          onError={(e) => {
            if (product?.slug && !e.currentTarget.dataset.fallback) {
              e.currentTarget.dataset.fallback = '1';
              e.currentTarget.src = bottleImg(product.slug);
              return;
            }
            e.currentTarget.style.display = 'none';
          }}
        />
      ) : (
        <div className="w-10 h-10 rounded-full bg-[#E5DCC9]" aria-hidden />
      )}
    </div>
  );
}
